var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftMoveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4996 6.15156C12.5743 6.15156 6.14961 12.5763 6.14961 20.5016C6.14961 28.4268 12.5743 34.8516 20.4996 34.8516C28.4249 34.8516 34.8496 28.4268 34.8496 20.5016C34.8496 12.5763 28.4249 6.15156 20.4996 6.15156ZM13.85 21.7699L19.2312 27.1512C19.9317 27.8517 21.0675 27.8517 21.768 27.1512C22.4685 26.4507 22.4685 25.3149 21.768 24.6144L19.4489 22.2953L25.8809 22.2953C26.8715 22.2953 27.6746 21.4922 27.6746 20.5016C27.6746 19.5109 26.8715 18.7078 25.8809 18.7078L19.4489 18.7078L21.768 16.3887C22.4685 15.6882 22.4685 14.5524 21.768 13.8519C21.0675 13.1514 19.9317 13.1514 19.2312 13.8519L13.85 19.2332C13.1495 19.9337 13.1495 21.0694 13.85 21.7699Z",
    fill: "#0076A8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftMoveIcon);
export default __webpack_public_path__ + "static/media/left-move-Icon.7c3bcb28af89a68e179175f3c093410e.svg";
export { ForwardRef as ReactComponent };